export enum UndoRedoActionEnum {
  UNDO = 'undo',
  REDO = 'redo',
}
